import React, { useEffect } from 'react';

/**
 * Wrapper pour la landing page qui force le mode clair
 * Empêche l'application du thème sombre sur la landing page
 */
const LandingPageWrapper = ({ children }) => {
  useEffect(() => {
    // Sauvegarder l'état actuel du thème
    const currentTheme = document.documentElement.classList.contains('dark') ? 'dark' : 'light';
    
    // Forcer le mode clair
    document.documentElement.classList.remove('dark');
    document.documentElement.classList.add('light');
    
    // Nettoyer au démontage du composant
    return () => {
      // Restaurer le thème précédent
      document.documentElement.classList.remove('light');
      if (currentTheme === 'dark') {
        document.documentElement.classList.add('dark');
      }
    };
  }, []);

  return (
    <div className="light-theme min-h-screen bg-white text-gray-900">
      {children}
    </div>
  );
};

export default LandingPageWrapper;

